export interface SearchPreviewResponse {
    /* The total number of results */
    callNumber: number;
    /* result html */
    searchResultHtml: string;
}
